/**
 *
 * Asynchronously loads the component for DeepLinkPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
